/* ════ PLANNER / LIST FILTERS ══════════════════════════════ */
import { state } from './state.js';
import { $ } from './dom.js';
import { buildGantt } from './gantt/index.js';
import { renderList } from './listview.js';
import { setView } from './views.js';

function apply() { if (state.currentView === 'list') renderList(); else buildGantt(); }

// Keep the team (resource) dropdown in sync with the current resource list.
export function refreshFilterResources() {
  const sel = $('flt-res');
  if (sel) {
    const cur = state.filters.resource;
    sel.innerHTML = '<option value="all">All resources</option>' +
      state.resources.map(r => `<option value="${r.id}">${r.name}</option>`).join('');
    sel.value = state.resources.find(r => r.id === cur) ? cur : 'all';
  }
  refreshFilterRoles();
}

// Role dropdown is built from the distinct roles assigned to resources.
export function refreshFilterRoles() {
  const sel = $('flt-role'); if (!sel) return;
  const cur = state.filters.role;
  const roles = [...new Set(state.resources.map(r => r.role).filter(Boolean))].sort();
  sel.innerHTML = '<option value="all">All roles</option>' +
    roles.map(r => `<option value="${r}">${r}</option>`).join('');
  sel.value = roles.includes(cur) ? cur : 'all';
}

// Keep the client + team dropdowns in sync with the values present on tasks.
export function refreshFilterClients() {
  const sel = $('flt-client');
  if (sel) {
    const cur = state.filters.client;
    const clients = [...new Set(state.tasks.map(t => t.client).filter(Boolean))].sort();
    sel.innerHTML = '<option value="all">All clients</option>' + clients.map(c => `<option value="${c}">${c}</option>`).join('');
    sel.value = clients.includes(cur) ? cur : 'all';
  }
  const tsel = $('flt-team');
  if (tsel) {
    const cur = state.filters.team;
    const teams = [...new Set(state.tasks.map(t => t.team).filter(Boolean))].sort();
    tsel.innerHTML = '<option value="all">All teams</option>' + teams.map(t => `<option value="${t}">${t}</option>`).join('');
    tsel.value = teams.includes(cur) ? cur : 'all';
  }
}

export function initFilters() {
  $('flt-text').addEventListener('input', e => {
    state.filters.text = e.target.value.trim();
    // Search hits can be spread anywhere across the year, so surface them in
    // the List view (chronological) rather than a single planner window.
    if (state.filters.text && state.currentView === 'gantt') setView('list');
    else apply();
  });
  $('flt-cat').addEventListener('change', e => { state.filters.cat = e.target.value; apply(); });
  $('flt-res').addEventListener('change', e => { state.filters.resource = e.target.value; apply(); });
  $('flt-role').addEventListener('change', e => { state.filters.role = e.target.value; apply(); });
  $('flt-client').addEventListener('change', e => { state.filters.client = e.target.value; apply(); });
  $('flt-team').addEventListener('change', e => { state.filters.team = e.target.value; apply(); });
  $('flt-imp').addEventListener('change', e => { state.filters.importance = e.target.value; apply(); });
  $('flt-invoicing').addEventListener('change', e => { state.filters.invoicing = e.target.value; apply(); });
  // One-click preset: External work that hasn't been invoiced → open in the List.
  $('flt-toinvoice').addEventListener('click', () => {
    state.filters.cat = 'ext'; state.filters.invoicing = 'toinvoice';
    $('flt-cat').value = 'ext'; $('flt-invoicing').value = 'toinvoice';
    setView('list');
  });
  $('flt-hidedone').addEventListener('change', e => { state.filters.hideDone = e.target.checked; apply(); });
  $('flt-clear').addEventListener('click', () => {
    state.filters = { cat: 'all', resource: 'all', role: 'all', importance: 'all', text: '', client: 'all', team: 'all', invoicing: 'all', hideDone: false };
    ['flt-cat', 'flt-res', 'flt-role', 'flt-client', 'flt-team', 'flt-imp', 'flt-invoicing'].forEach(id => $(id).value = 'all');
    $('flt-text').value = ''; $('flt-hidedone').checked = false;
    apply();
  });
  refreshFilterResources();
  refreshFilterClients();
}
